import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { Bullet } from '@/pages/_app/applicants/case-detail/ui/history-list/bullet'

import { cn } from '@/lib/utils'

dayjs.extend(utc)

interface ApplicantCaseEoirDetailHistoryProps {
  statusList: {
    status: string
    date: string | null
  }[]
  className?: string
}

export const ApplicantCaseEoirDetailHistory: React.FC<ApplicantCaseEoirDetailHistoryProps> = ({
  statusList,
  className,
}) => {
  return (
    <div className={cn('relative flex', className)} role="list" aria-label="Case history timeline">
      {/* VERTICAL LINE */}
      <div className={`absolute bottom-0 left-0 top-0 w-[8.5px] border-r`} />

      {/* HISTORY ITEMS */}
      <div className="flex-1 space-y-3" role="list">
        {statusList?.map((x, i) => (
          <div className="flex" key={i}>
            <div className="relative mr-1 flex w-4 items-center justify-center">
              {/* Hide line for first and last item. */}
              {i === 0 && <div className="absolute bottom-1/2 left-0 right-0 top-0 bg-white" />}
              {i === statusList?.length - 1 && <div className="absolute bottom-0 left-0 right-0 top-1/2 bg-white" />}
              <Bullet />
            </div>

            <div className={cn('flex flex-1 flex-col gap-2', 'rounded-lg px-5 py-4', 'bg-secondary')}>
              <div className={cn('text-[14px] leading-[18px]')}>{x.status}</div>
              <div
                className={cn('text-[12px] leading-[18px]', {
                  'text-faint-foreground': !x.date,
                  'text-accent-foreground': !!x.date,
                })}
              >
                {x.date ? dayjs.utc(x.date).local().format('MMM D, YYYY') : 'No date'}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
